import React, {Component} from 'react';

export default class PageNotFound extends Component {
  render() {
    return (
      <div>
        <h1>
          404 - Page not found!
        </h1>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/PageNotFound.js